import React, { useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import * as Yup from 'yup';
import { assign } from 'lodash';
import { parse, addDays, format } from 'date-fns';

import { Report } from '~/components';
import { RadioGroup, Autocomplete, DateTime, Select } from '~/components/Form';
import {
  getEveryMonth,
  getYearsInterval,
  firstAndLastDayOfTheMonth,
} from '~/helpers/dateTime';

export default function DlgRelResumoOperacao() {
  const { profile } = useSelector((state) => state.user);

  const [open, setOpen] = useState(true);
  const [tank, setTank] = useState({});
  const [abstract, setAbstract] = useState('period');
  const [type, setType] = useState('ambiente');

  const optionsTypeReport = useMemo(
    () => [
      { label: 'Manifestado', value: 'manifestado' },
      { label: 'Ambiente', value: 'ambiente' },
      { label: '20º', value: '20' },
    ],
    []
  );

  const optionsTypeAbstract = useMemo(
    () => [
      { label: 'Período', value: 'period' },
      { label: 'Mensal', value: 'monthly' },
    ],
    []
  );

  const optionsTypeAgroup = useMemo(
    () => [
      { label: 'Turno', value: 'turno' },
      { label: 'Dia', value: 'dia' },
      ...(type === 'ambiente'
        ? [{ label: 'Dia Base 00:00hs', value: 'diabase' }]
        : []),
    ],
    [type]
  );

  const optionsTypeRadio = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'xls' },
    ],
    []
  );

  const months = useMemo(
    () =>
      getEveryMonth().map((month, key) => ({
        value: key + 1,
        label: month,
      })),
    [getEveryMonth]
  );

  const years = useMemo(
    () =>
      getYearsInterval(10).map((year) => ({
        value: year,
        label: year,
      })),
    [getYearsInterval]
  );

  const handleModifyReportData = useCallback(
    (data) => {
      delete data.abstract;

      const days = data.mes
        ? firstAndLastDayOfTheMonth(data.ano, data.mes, 'dd/MM/yyyy')
        : {};

      const formData = assign(data, {
        
        idtarefapath: "dlgRelResumoOperacao.swf",

        strposto: tank.post_desc,
        usuario: profile.username,
        strusuario: profile.name,
        ...(data.mes
          ? {
              datainicial: days.first,
              datafinal: days.last,
              datafinalplus: format(
                addDays(parse(days.last, 'dd/MM/yyyy', new Date()), 1),
                'dd/MM/yyyy'
              ),
            }
          : {}),
        ...(data.datafinal
          ? {
              datafinalplus: format(
                addDays(parse(data.datafinal, 'dd/MM/yyyy', new Date()), 1),
                'dd/MM/yyyy'
              ),
            }
          : {}),
      });

      return formData;
    },
    [tank, profile]
  );

  const handleValidationForm = useCallback(
    async (data) => {
      if (abstract === 'period') {
        const schema = Yup.object().shape({
          posto: Yup.string()
            .typeError('Campo obrigatório')
            .required('Campo obrigatório'),
          datainicial: Yup.string()
            .typeError('Campo obrigatório')
            .required('Campo obrigatório'),
          datafinal: Yup.string()
            .typeError('Campo obrigatório')
            .required('Campo obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
      } else {
        const schema = Yup.object().shape({
          posto: Yup.string()
            .typeError('Campo obrigatório')
            .required('Campo obrigatório'),
          mes: Yup.string()
            .typeError('Campo obrigatório')
            .required('Campo obrigatório'),
          ano: Yup.string()
            .typeError('Campo obrigatório')
            .required('Campo obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
      }
    },
    [abstract]
  );

  return (
    <Report
      open={open}
      title="Relatório Resumo da Operação"
      relatorio="RESUMOOPERACAO"
      onClose={() => setOpen(false)}
      serialize={handleModifyReportData}
      validate={handleValidationForm}
      initials={{
        tiporel: 'ambiente',
        abstract: 'period',
        agruparrel: 'turno',
        mes: format(new Date(), 'M'),
        ano: format(new Date(), 'yyyy'),
        tipo: 'pdf',
      }}
    >
      <RadioGroup
        row
        name="tiporel"
        label="Tipo"
        options={optionsTypeReport}
        getValue={(value) => setType(value)}
      />

      <Autocomplete
        name="posto"
        label="post_desc"
        url="usuarioposto"
        unique="post_cod_posto"
        title="Posto"
        getValue={(value) => setTank(value)}
        params={{
          wherefield: 'post_controla_20',
          valuewherefield: type === '20' ? 'N' : 'T',
          typewherefield: 'NEQUALS',
        }}
      />

      <RadioGroup
        row
        name="abstract"
        label="Resumo"
        options={optionsTypeAbstract}
        getValue={(value) => setAbstract(value)}
      />

      <RadioGroup
        row
        name="agruparrel"
        label="Agrupar"
        options={optionsTypeAgroup}
        style={{ marginBottom: '1.5rem' }}
      />

      {abstract === 'period' ? (
        <>
          <DateTime name="datainicial" label="Data Inicial" />
          <DateTime name="datafinal" label="Data Final" />
        </>
      ) : (
        <>
          <Select name="mes" label="Mês" options={months} />
          <Select name="ano" label="Ano" options={years} />
        </>
      )}

      <RadioGroup
        row
        name="tipo"
        label="Formato de Saída"
        options={optionsTypeRadio}
      />
    </Report>
  );
}
